<template>
    <main v-if="data && data.page">
        <div class="splashZone">
            <div class="infoBar">
                <WebsiteBreadcrumbs>
                    <NuxtLink to="/about/who-we-are">About</NuxtLink>
                    <a>Member Federations</a>
                </WebsiteBreadcrumbs>
            </div>
            <h1 class="helvetica title1">{{ data.page.country }}</h1>
        </div>

        <section class="cover">
            <div class="country">
                <div class="logo">
                    <Image :image="data.page.company_logo" :width="180" :mobileWidth="180" imageClass="contain" />
                </div>
                <div class="info">
                    <h4 class="title4">{{ data.page.company_name }}</h4>
                    <div class="title6" v-html="data.page.company_contacts" />
                </div>
            </div>
            <div class="representative" v-if="data.page.representative">
                <h4 class="title4 capitalize">Member federation representative</h4>
                <ItemMemberBoard :member="data.page.representative" />
            </div>
        </section>

        <section class="companies" v-if="data.page.companies && data.page.companies.length > 0">
            <div class="wrapper">
                <h2 class="baron headerText">Companies</h2>
                <div class="companies-grid">
                    <div v-for="company in data.page.companies">
                        <div class="square">
                            <Image v-if="company.logo" :image="company.logo" :alt="company.name" :width="80" :mobileWidth="160" imageClass="contain" />
                        </div>
                        <div>{{ company.name }}</div>
                        <a :href="company.link" class="overlink" target="_blank" rel="noreferer noopener"></a>
                    </div>
                </div>
            </div>
        </section>
        <WebsiteFooter />
    </main>
</template>
<script lang="ts" setup>
const { getFederationPage } = usePages();
const route = useRoute()
const { data } = useAsyncData(`about-federation-${route.params?.slug}`, () => getFederationPage(route.params?.slug));

useSeoMeta({
    title: () => `${data.value?.page.country} | Member Federations | About | EIC Federation`,
    ogTitle: () => `${data.value?.page.country} | Member Federations | About | EIC Federation`,
    twitterTitle: () => `${data.value?.page.country} | Member Federations | About | EIC Federation`,
})
</script>
<style lang="scss" scoped>
main {
    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-sections);



    .splashZone {
        position: relative;
        padding-top: var(--size-padding-header);

        .infoBar {
            padding: 0 var(--size-margin-page);
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: var(--size-margin-page);

            margin-bottom: var(--size-gutter-default);
            color: var(--color-primary);
        }

        h1 {
            margin-bottom: var(--size-gutter-double);
            padding: 0 var(--size-margin-page);
        }
    }



    .cover {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: var(--size-gutter-small);
        padding: 0 var(--size-margin-page);

        >div {
            border-left: var(--size-thickness) solid var(--color-primary);
        }

        .country {
            display: flex;
            flex-direction: row;
            gap: var(--size-gutter-double);
            padding-left: var(--size-gutter-double);

            .logo {
                position: relative;
                width: 160px;
                height: 160px;

                &:deep(.responsivePicture) {
                    background-image: none !important;

                    img {
                        object-position: top center;
                    }
                }
            }

            .info {
                display: flex;
                flex-direction: column;
                gap: var(--size-gutter-default);
            }
        }

        .representative {
            display: flex;
            flex-direction: column;
            gap: var(--size-gutter-default);
            padding-left: var(--size-gutter-double);

            &:deep(.boardMember) {
                border: none;
                padding: 0;
            }
        }

    }


    .companies {
        margin: 0 var(--size-margin-page);

        padding-top: var(--size-margin-page);
        border-top: var(--size-thickness) solid var(--color-primary);

        h2 {
            color: var(--color-primary);
        }


        .companies-grid {
            display: grid;
            grid-template-columns: repeat(8, 1fr);
            gap: var(--size-gutter-double) var(--size-gutter-small);
            padding-top: var(--size-gutter-double);

            >div {
                position: relative;
                height: 100%;
                border-left: var(--size-thickness) solid var(--color-primary);
                padding-left: var(--size-gutter-default);

                .square {
                    position: relative;
                    width: 80px;
                    height: 80px;
                    margin-bottom: var(--size-gutter-small);

                    &:deep(.responsivePicture) {
                        background-image: none !important;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    main {
        .cover {
            display: flex;
            flex-direction: column;
            gap: var(--size-gutter-large);

            >div {
                border: none;
            }

            .country {
                padding-left: 0;

                flex-direction: column;

                h4 {
                    text-wrap: balance;
                }
            }

            .representative {
                padding-left: 0;

                display: grid;
                grid-template-columns: min-content 1fr;

                h4 {
                    grid-column: 1 / span 2;
                }

                .cover-image {
                    width: 80px;
                    height: 80px;
                }
            }
        }

        .companies {
            .companies-grid {
                grid-template-columns: repeat(5, 1fr);
                gap: var(--size-gutter-default);
            }
        }
    }
}

@media screen and (max-width: 768px) {
    main {
        .companies {
            .companies-grid {
                grid-template-columns: repeat(3, 1fr);
                gap: var(--size-gutter-default);
            }
        }
    }
}

@media screen and (max-width: 600px) {

    main {
        .companies {
            .companies-grid {
                grid-template-columns: repeat(2, 1fr);
                gap: var(--size-gutter-default);
            }
        }
    }
}
</style>